import React from "react";
import PropTypes from "prop-types";

// components
import Notes from "./notes";
import Loader from "./loader";

export default function NotesSection({ loading, ...rest }) {
    if (loading) {
        return <Loader />;
    }

    return <Notes {...rest} />;
}

NotesSection.propTypes = {
    loading: PropTypes.bool,
};
